import PayrollCreatePeriod from "../components/PayrollCreatePeriod";
import usePayrollPeriodCreate from "../hook/usePayrollPeriodCreate";

const PayrollPeriodCreatePage = () => {
    const usePayrollPeriodProps = usePayrollPeriodCreate();

    return <PayrollCreatePeriod {...usePayrollPeriodProps} />;
};

export default PayrollPeriodCreatePage;
